export enum NotificationTypeEnum {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}
